import { CreditReportEmploymentInformation } from "types/landlord/reports";
import { Row } from "views/applications-id-report/components/Row";
import { Section } from "views/applications-id-report/components/Section";

interface EmploymentInformationProps {
  employment_information?: CreditReportEmploymentInformation[];
  isNoHit: boolean;
}

export const EmploymentInformation = ({
  employment_information,
  isNoHit
}: EmploymentInformationProps) => {
  if (isNoHit)
    return (
      <Section sectionTitle="Employment information">
        <p className="text-base font-medium text-content-300">
          No data available
        </p>
      </Section>
    );

  return (
    <Section sectionTitle="Employment information">
      <div className="flex flex-col gap-4">
        {employment_information?.length ? (
          employment_information.map((employment, index) => {
            return (
              <div
                key={`${employment.employer}_${employment.date_last_reported}`}
              >
                <p className="pb-6 text-sm font-bold text-content-1000">
                  {index === 0 ? "Last Reported Employment" : "Former Employer"}
                </p>
                <div className="flex flex-wrap ">
                  <div className="flex w-1/2 flex-col gap-3">
                    <Row title="Occupation" value={employment.occupation} />
                    <Row title="Employer" value={employment.employer} />
                  </div>
                  <div className="flex w-1/2 flex-col gap-3">
                    <Row
                      title="Date First Reported"
                      value={employment.date_first_reported}
                    />
                    <Row
                      title="Date Last Reported"
                      value={employment.date_last_reported}
                    />
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p className="text-base font-medium">No data available</p>
        )}
      </div>
    </Section>
  );
};
